<template>
  <div class="content">
    <!-- 搜索条件 -->
    <div class="block block-form">
      <div class="block-tilte">推广订单</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="推广位名称">
          <el-select v-model="searchForm.state" placeholder="请选择推广位名称">
            <el-option v-for="item in status_list" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="searchForm.orderNo" placeholder="请输入订单编号" />
        </el-form-item>
        <el-form-item label="拦截状态">
          <el-select v-model="searchForm.interceptStatus" placeholder="请选择拦截状态">
            <el-option v-for="item in interceptStatus" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单订单类型">
          <el-radio-group style="margin-left: 10px" v-model="searchForm.orderType" @input="selectType">
            <el-radio label="">全部</el-radio>
            <el-radio :label="1">特惠单</el-radio>
            <el-radio :label="3">秒出单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="下单日期">
          <date-picker type="date" placeholder="开始日期" v-model="searchForm.start_time_bak" style="width: 150px;">
          </date-picker>
          <span style="padding: 0 5px;">至</span>
          <date-picker type="date" placeholder="结束日期" v-model="searchForm.end_time_bak"
            style="width: 150px;"></date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button style="margin-left:12px" type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button @click="onFormExport">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="block block-top">
      <Table border :columns="columns" :data="list" :loading="listLoading">
        <template slot-scope="{ row }" slot="proportion">
          <span>{{ row.commissionRate }}%</span>
        </template>
        <template slot-scope="{ row }" slot="state">
          <span v-if="row.state == 6">待出票</span>
          <span v-if="row.state == 8">已出票</span>
          <span v-if="row.state == 9">已读票</span>
          <span v-if="row.state == 10">未结算</span>
          <span v-if="row.state == 20">已结算</span>
          <span v-if="row.state == 15">订单失效</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <!-- v-if="(row.stateStr == '待出票')" -->
          <div class="color-ff4" style="cursor: pointer;color: #FF9734;" v-if="row.canIntercept"
            @click="interceptBtn(row)">拦截订单</div>
          <div class="color-ff4" style="cursor: pointer;color: #3D9EFC;" v-if="row.canCuiTicket == 0"
            @click="urgeBill(row)">催出票</div>
          <div class="color-ff4" style="cursor: pointer;color: #3D9EFC;" v-if="row.canCuiTicket == 1">已催</div>
          <div class="color-ff4" style="cursor: pointer;color: #FF9734;" v-if="row.canCancelIntercept"
            @click="cancelOrderBtn(row)">取消拦截</div>
          <div class="color-ff4" style="cursor: pointer" @click="showDetail(row)">查看详情</div>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
    <detail ref='detail'></detail>
    <commission-detail ref='commissionDetail'></commission-detail>

    <!--取消拦截-->
    <el-dialog title="取消拦截" :visible.sync="dialog_close" width="500px">
      <div class="dialog-content">确认取消拦截？</div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_close = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_closeBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--取消拦截-->
    <!--拦截订单-->
    <el-dialog title="拦截订单" :visible.sync="dialog_intercept" width="460px">
      <div class="dialog-content">
        <div class="box">
          <div style="margin-right: 16px;text-align: center">确定发起拦截？发起拦截后。不保证拦截成功</div>
          <!--          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3}" placeholder="请输入拦截原因" v-model="interceptReason" style="flex: 1;">-->
          <!--          </el-input>-->
        </div>
        <div>
          <span style="color: red;margin-top: 10px">请稍后刷新页面查看结果</span>
        </div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_intercept = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_interceptBtnOk">确定</div>
      </div>
    </el-dialog>
    <!--拦截订单-->
    <!--    拦截成功提示-->
    <el-dialog title="提示" :visible.sync="hintShow" width="40%" :before-close="handleClose">
      <div class="dialog-content">
        <div>
          <div class="dialog-text">已发起拦截。不保证拦截成功，<span style="color: red">请稍后刷新页面查看结果</span></div>
        </div>
        <div class="dialogFooter">
          <div class="dialogFooter-ok" @click="hintShow = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <!--催出票-->
    <el-dialog title="催出票" :visible.sync="dialog_urge" width="460px">
      <div class="dialog-content">
        <div class="hint">确定催促出票？</div>
        <div class="placeholder">每个订单10分钟内只能发起一次催出票。</div>
      </div>
      <div class="dialogFooter">
        <div class="dialogFooter-off" @click="dialog_urge = false">取消</div>
        <div class="dialogFooter-ok" style="margin-left: 10px;" @click="dialog_urgeBtnOk()">确定</div>
      </div>
    </el-dialog>
    <!--催出票-->

  </div>
</template>
<script>
import { getPlatformUuid, getToken, getUserUUID, getPlatformName, getHeadImg } from '@/utils/auth'
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker } from 'view-design'
//import { getOrderList } from '@/api/order'
import Detail from '@/components/official/TicketDetail.vue'
import CommissionDetail from '@/components/official/CommissionDetail.vue'
import { getDate, numFormatter } from '@/utils/date'
import order from '@/javaApi/order'
const orderModel = new order()
export default {
  name: 'Order',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
    Detail,
    CommissionDetail
  },
  data: function () {
    return {
      platformName: getPlatformName(),
      headImg: getHeadImg(),
      dialog_close: false,
      dialog_intercept: false,
      dialog_urge: false,
      testlist: [{ state: 8 }],
      interceptStatus: [
        { label: '全部', value: '' },
        { label: '未拦截', value: '-1' },
        { label: '已拦截', value: '1' }
      ],
      columns: [
        {
          title: '影票信息',
          key: 'movie_info',
          fixed: 'left',
          width: 250,
          render: (h, params) => {
            let movieInfo = params.row.movieInfo
            if (movieInfo !== '') {
              movieInfo = JSON.parse(movieInfo)
            }
            let movieName = movieInfo[5]
            let movieImage = movieInfo[6]
            let ticketNum = params.row.number + '张'

            let renderData = []
            // if (movieImage) {
            //   renderData.push(
            //     h('img', {
            //       attrs: {
            //         src: movieImage,
            //         style: 'width: 30%;height: auto;margin:15px;float:left;cursor:pointer;'
            //       }
            //     })
            //   )
            // }
            renderData.push(
              h(
                'span',
                {
                  attrs: {
                    style: 'display: block;cursor: pointer;margin-top: 15px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;color:#3A94F2;width: 200px;text-align: center;'
                  }
                },
                movieName
              )
            ),
              renderData.push(
                h(
                  'span',
                  {
                    attrs: {
                      style: 'display: block;cursor: pointer;margin-top: 15px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 200px;text-align: center;'
                    }
                  },
                  ticketNum
                )
              )
            //return renderData
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    background: 'none'
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row)
                    }
                  }
                },
                renderData
              )
            ])
          }
        },
        {
          title: '订单编号',
          key: 'orderNo',
          width: 180
        },
        {
          title: '市场价',
          key: 'marketPrice',
          width: 100
        },
        {
          title: '支付金额（元）',
          key: 'price',
          width: 150,
          render: (h, params) => {
            let marketPrice = params.row.orderPrice
            let renderData = []
            renderData.push(marketPrice)
            return renderData
          }
        },
        {
          title: '下单会员',
          key: 'nickName_info',
          width: 120,
          render: (h, params) => {
            let nickName = params.row.nickName
            let renderData = []
            renderData.push(params.row.nickName)
            renderData.push('(' + params.row.sourceId + ')')
            return renderData
          }
        },
        {
          title: '订单总佣金',
          key: 'commissionTotal',
          width: 120,
          className: 'color-blue',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    background: 'none'
                  },
                  on: {
                    click: () => {
                      this.showCommissionDetail(params.row)
                    }
                  }
                },
                params.row.commissionTotal
              )
            ])
          }
        },
        {
          title: '佣金比例',
          key: 'proportion',
          slot: 'proportion',
          width: 110,
        },
        {
          title: '下单时间',
          key: 'createTime',
          width: 120
        },
        {
          title: '订单状态',
          key: 'state',
          slot: 'state',
          width: 110
        },
        {
          title: '结算时间',
          key: 'settleTime',
          width: 120
        },
        {
          title: '拦截状态',
          key: 'interceptStatusStr',
          width: 110
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          slot: 'action',
          align: 'center'
        }
      ],
      listLoading: false,
      status_list: [
        { label: '全部', value: '' },
        { label: '待出票', value: '6' },
        { label: '已出票', value: '8' },
        { label: '已读票', value: '9' },
        { label: '已结算', value: '20' },
        { label: '订单失效', value: '15' }
      ],
      list: [],
      activeRow: {},
      interceptReason: '用户取消',
      total: 0,
      platformUuid: getPlatformUuid(),
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        state: undefined,
        phone: undefined,
        nickName: undefined,
        orderNo: undefined,
        sourceId: undefined,
        commissionMix: undefined,
        commissionMax: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        platformUuid: undefined,
        userUuid: undefined,
        orderType: 1,
        loginUUId: getUserUUID()
      },
      hintShow: false
    }
  },
  created() {
    let param = this.$route.query
    if (param.user_id) {
      this.searchForm.userUuid = param.user_id
    }
    if (param.nick_name) {
      this.searchForm.nickName = param.nick_name
    }
    // 默认时间选择框下单时间为7天
    this.searchForm.start_time_bak = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
      this.searchForm.end_time_bak = new Date()

    this.getList(true)
  },
  methods: {
    handleClose() {
      this.hintShow = false
    },
    urgeBill(row) {
      console.log('row', row)
      this.dialog_urge = true
      this.activeRow = row
    },
    dialog_urgeBtnOk() {
      orderModel
        .urgeBill({
          orderUUID: this.activeRow.orderNo
        })
        .then(res => {
          console.log('res', res)
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_urge = false
            this.getList(true)
          } else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    dialog_interceptBtnOk() {
      orderModel
        .InterceptOrder({
          orderUUID: this.activeRow.orderNo,
          interceptReason: this.interceptReason,
          // applicantName: this.platformName,
          applicantName: '开放平台',
          applicantUrl: this.headImg
        })
        .then(res => {
          console.log(res)
          if (res.data.success) {
            this.$Message.success('成功')
            // this.hintShow = true
            this.dialog_intercept = false
            this.getList(true)
          } else {
            this.$Message.warning(res.data.message)
          }
        })

    },
    dialog_closeBtnOk() {
      orderModel
        .cancelOrder({
          orderUUID: this.activeRow.orderNo
        })
        .then(res => {
          console.log(res)
          if (res.data.success) {
            this.$Message.success('成功')
            this.dialog_close = false
            this.getList(true)
          } else {
            this.$Message.warning(res.data.message)
          }
        })
    },
    interceptBtn(row) {
      // this.interceptReason = ''
      console.log('row', row)
      this.dialog_intercept = true
      this.activeRow = row
    },
    cancelOrderBtn(row) {
      console.log('row', row)
      this.dialog_close = true
      this.activeRow = row
    },
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      // 如果查询的参数为空直接unset 掉
      searchForm = this.formateInit(searchForm)
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (!condition) {
        searchForm.platformUuid = this.platformUuid
      }
      let createTimeStartStr = getDate(searchForm.start_time_bak)
      if (createTimeStartStr) {
        searchForm.createStartTime = createTimeStartStr + ' 00:00:00'
      } else {
        delete searchForm.createStartTime
      }
      let createTimeEndStr = getDate(searchForm.end_time_bak)
      if (createTimeEndStr) {
        searchForm.createEndTime = createTimeEndStr + ' 23:59:59'
      } else {
        delete searchForm.createEndTime
      }

      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      if (searchForm.sourceId) {
        searchForm.sourceId = numFormatter(searchForm.sourceId)
      }
      orderModel.getOrderList(searchForm).then(response => {
        var res = response.data
        this.listLoading = false
        if (res.code != 200) {
          this.$Message.error(res.message)
          return
        }
        this.list = res.data.list
        this.total = res.data.total
      })
    },
    formateData(data) {
      if (!data) {
        return []
      }
      if (!data.length) {
        return []
      }
      let i = 0
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for (i = 0; i < data.length; i++) {
        data[i].sequence = i + 1 + (pageNo - 1) * pageSize
      }
      return data
    },
    formateInit(formData) {
      let objCopy = {}
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key]
        }
      }
      return objCopy
    },
    onFormSearch() {
      this.getList(true)
    },
    onFormReset() {
      this.searchForm.state = undefined
      this.searchForm.phone = undefined
      this.searchForm.nickName = undefined
      this.searchForm.orderNo = undefined
      this.searchForm.sourceId = undefined
      this.searchForm.commissionMix = undefined
      this.searchForm.commissionMax = undefined
      this.searchForm.start_time_bak = undefined
      this.searchForm.end_time_bak = undefined
      this.searchForm.createStartTime = undefined
      this.searchForm.createEndTime = undefined
      this.searchForm.interceptStatus = undefined
      this.searchForm.orderType = ''
      this.getList(true)
    },
    //订单导出
    onFormExport() {
      this.listLoading = true
      let searchForm = Object.assign({}, this.searchForm)
      // 如果查询的参数为空直接unset 掉
      searchForm = this.formateInit(searchForm)
      let condition = this.platformUuid == '' || this.platformUuid == 0
      if (!condition) {
        searchForm.platformUuid = this.platformUuid
      }
      let createTimeStartStr = getDate(searchForm.start_time_bak)
      if (createTimeStartStr) {
        searchForm.createStartTime = createTimeStartStr + ' 00:00:00'
      } else {
        delete searchForm.createStartTime
      }
      let createTimeEndStr = getDate(searchForm.end_time_bak)
      if (createTimeEndStr) {
        searchForm.createEndTime = createTimeEndStr + ' 23:59:59'
      } else {
        delete searchForm.createEndTime
      }

      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      delete searchForm.pageNo
      delete searchForm.pageSize
      this.$Message.success('正在下载...')
      searchForm.xToken = getToken()
      searchForm.uuid = getUserUUID()
      searchForm = this.formateInit(searchForm)
      orderModel.exportOrder(searchForm).then(res => {
        this.listLoading = false
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        let url = window.URL.createObjectURL(blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = window.URL.createObjectURL(blob)
        a.download = '订单导出_' + this.formatDate(new Date()) + '.xls'
        a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    formatDate(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      return y + m + d
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    showDetail(row) {
      this.$refs.detail.init(row)
    },
    // 佣金详情
    showCommissionDetail(row) {
      this.$refs.commissionDetail.init(row)
    },
    // 选择类型
    selectType(e) {
      this.searchForm.orderType = e
      this.getList()
    }
  }
}
</script>
<style scoped lang="less">
/deep/.el-dialog__body {
  padding: 0;
  padding-bottom: 20px;
}

.flex {
  display: flex;
  align-items: center;
}

.dialog-content {
  min-height: 120px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .box {
    //width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 25px;

    span {
      color: red;
    }

    // margin-top: 30px;
  }

  .hint {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
  }

  .placeholder {
    margin-top: 10px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

.dialogFooter {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;

  div {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .dialogFooter-ok {
    background-color: #ff8622;
    color: #ffffff;
  }
}

.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 30px;
}

.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: '\F33D';
}

.ivu-date-picker-rel {
  margin: 11px 0;
}

.ivu-table {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 2px;
}

.table-wrapper .ivu-table-header th {
  background-color: #fcfaf8 !important;
}

.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #ffffff !important;
}

.ivu-table td.color-blue .ivu-table-cell {
  color: #3a94f2;
}

.search-text {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
}

.block-tilte {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/order/Index.vue